import * as React from "react";
import styled from "styled-components";
import theme from "themes/simple-theme";

const Header = styled.header`
  text-align: center;
  text-transform: uppercase;
  & a {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-decoration: none;
  }
  padding-top: ${theme.global.gutter * 0.7}rem;
  padding-right: ${theme.global.gutter * 0.7}rem;
  padding-left: ${theme.global.gutter * 0.7}rem;
  padding-bottom: ${theme.global.gutter * 0.7}rem;
  background-color: ${theme.color.primary};
  color: ${theme.color.white};
`;

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/index.tsx